import { csrfHeader } from '~/utils/csrf'
import { encodeAsJSON, responseAsJSON } from '~/utils/json'

const jsonHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}

export function postJSON(url, params = {}, headers = {}) {
  const abortController = new AbortController()
  const fullUrl = new URL(url, document.location).toString()

  const options = {
    signal: abortController.signal,
    method: 'POST',
    headers: { ...csrfHeader(), ...jsonHeaders, ...headers },
    body: encodeAsJSON(params),
  }

  const request = fetch(fullUrl, options).then(responseAsJSON)

  return { request, abortController }
}
